/*
 * @Author: Teemo Ding
 * @Date: 2022-04-13 09:59:50
 * @LastEditTime: 2022-06-20 16:46:53
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionList/config.tsx
 */
import Link from '@/src/components/Link/Link';
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import css from './style.module.less';
import {
  handleOnGetStoreTimezoneUTC,
  handleOnFormatStoreTimeAndDateWithTimezone,
} from '@/src/tools/tools';

export const columns = (timeZone, disableView: boolean, { getI18n }) => [
  {
    title: getI18n('usersAndPermissions.list.userName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 272,
    childGenerate: (a, record, index) => {
      const {
        email = '',
        mobile = '',
        areaCode = '',
        currentUser = false,
      } = record || {};
      const text = email
        ? `${email} ${
            currentUser ? `(${getI18n('usersAndPermissions.list.you')})` : ''
          }`
        : `+${areaCode}${mobile} ${
            currentUser ? `(${getI18n('usersAndPermissions.list.you')})` : ''
          }`;
      return (
        <NoWrapContainer>
          <Tooltip title={text}>{text}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('usersAndPermissions.list.userName'),
    dataIndex: 'fullName',
    key: 'fullName',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 160,
  },
  {
    title: getI18n('usersAndPermissions.list.roles'),
    dataIndex: 'roles',
    key: 'roles',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 320,
    childGenerate: (text, _, index) => {
      const value = text.map((item) => item.name);
      return (
        <NoWrapContainer>
          <Tooltip
            title={
              index === 0
                ? getI18n('usersAndPermissions.list.superAdministratorOwner')
                : value.toString()
            }>
            {index === 0
              ? getI18n('usersAndPermissions.list.superAdministratorOwner')
              : value.toString()}
          </Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: `${getI18n(
      'usersAndPermissions.list.accountActivities',
    )} (UTC ${handleOnGetStoreTimezoneUTC()})`,
    dataIndex: ['latestActivity', 'modifiedDate'],
    key: 'latestActivity',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 240,
    childGenerate: (text, record) => {
      const date = text
        ? `${getI18n(
            'usersAndPermissions.list.lastlogin',
          )} ${handleOnFormatStoreTimeAndDateWithTimezone(text)}`
        : `${getI18n(
            'usersAndPermissions.list.invitesenton',
          )} ${handleOnFormatStoreTimeAndDateWithTimezone(record.createdDate)}`;
      return (
        <NoWrapContainer>
          <Tooltip title={date}>{date}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  disableView
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'action',
        key: 'action',
        default: true,
        optional: false,
        className: css.columnClass,
        minWidth: 96,
        render: (text, record, index) => {
          const { currentUser = false } = record || {};
          return index === 0 ? (
            ''
          ) : (
            <Link
              className={css.action}
              to={`/settings/permissionsDetail/${record.uuid}`}>
              {currentUser ? getI18n('general.view') : getI18n('general.edit')}
            </Link>
          );
        },
      },
];

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('usersAndPermissions.list.usersandPermissions'),
  },
];
